import React, {Component} from 'react';
import NavList from '../widgets/NavList';
import NavListItem from '../widgets/NavListItem';
import {connect} from 'react-redux';
import {actions} from './users.state';
import {push} from 'react-router-redux';
import handleError from '../handleError';
import jsonFetch from '../jsonFetch';
import debounce from '../debounce';
import {actions as dirtyActions} from '../dirty.state';
import {admin_syllabus, admin_user} from '../permissions';

export class UsersList extends Component {
	constructor(props) {
		super(props);
		
		props.userListRetrieving([]);
		jsonFetch(`${process.env.REACT_APP_API}/user`)
			.then(json => this.props.userListRetrieved(json))
			.catch(props.handleError);
		
		/**
		 * Perform search query after a delay
		 */
		const doSearchAfterDelay = debounce(value => {
			props.userListRetrieving([]);
			jsonFetch(`${process.env.REACT_APP_API}/user?query=${encodeURIComponent(value)}`)
				.then(json => this.props.userListRetrieved(json))
				.catch(props.handleError)
		}, 500);
		this.doSearchAfterDelay = e => doSearchAfterDelay(e.target.value.trim());
	}
	
	render() {
		const {
			users: {
				items,
				retrieving
			},
			isDirty,
			newUser
		} = this.props;
		
		return (
			<NavList
				className="UsersList"
				theme="midnight-blue"
				disabled={isDirty}
				loading={retrieving}
				onAdd={newUser}
				onSearchChange={this.doSearchAfterDelay}
			>
				{items
						.sort((a, b) => {
							const [aName, bName] = [(a.firstname + a.lastname).toLowerCase(), (b.firstname + b.lastname).toLowerCase()];
							return aName < bName ? -1 : aName > bName ? 1 : 0;
						})
						.map(user => (
					<NavListItem
						disabled={isDirty}
						key={user.email}
						to={`/user/${user.email}`}
						backgroundUrl={user.imagePath}
						name={`${user.firstname} ${user.lastname}`}
						status={(user.permissions && user.permissions.length) ? user.permissions.map(priv => {
							switch (priv) {
								case admin_syllabus:
									return 'Syllabus';
								case admin_user:
									return 'Users';
								default:
									return null;
							}
						}).filter(priv => !!priv).join(', ') : 'No access'}
						theme="midnight-blue"
					/>
				))}
			</NavList>
		);
	}
}

const ConnectedUsersList = connect(
	({users, dirty}) => ({
		users,
		isDirty: !!(dirty && dirty.keys && Object.keys(dirty.keys).length)
	}),
	dispatch => ({
		userListRetrieving: () => dispatch(actions.userListRetrieving()),
		userListRetrieved: data => dispatch(actions.userListRetrieved(data)),
		newUser: () => {
			dispatch(actions.userNew());
			dispatch(push('/user/new'));
			dispatch(dirtyActions.dirtySet('new'));
		},
		handleError: handleError(dispatch)
	})
)(UsersList);

export default ConnectedUsersList;


// WEBPACK FOOTER //
// ./src/users/UsersList.js